import React from 'react';
import { FormattedMessage } from 'react-intl';
import { LoginModalFooter } from './components';
import { Modal } from '../components/modal/Modal';
import { ConnectionForm } from './components/connection-form/ConnectionForm';
import { doctrineAnalytics } from '../utils/analyticsUtils';
import { ResetPasswordModal } from './components/reset-password-modal/ResetPasswordModal';
import { MaterialIcon } from '../components/material-icon/MaterialIcon';
import styles from './login_modal.module.scss';

type Props = {
  closeModal: () => void;
  isOpen: boolean;
  source: string;
};

type State = {
  isForgotPasswordStep: boolean;
};

export class LoginModal extends React.Component<Props, State> {
  static defaultProps = {
    closeModal: () => {},
    isOpen: false,
  };

  state: State = {
    isForgotPasswordStep: false,
  };

  componentDidMount() {
    const { source } = this.props;
    doctrineAnalytics('Account ModalLoginAppeared2', { source });
  }

  switchToForgotPassword = () => {
    doctrineAnalytics('Account ModalResetPasswordAppeared');
    this.setState(({ isForgotPasswordStep }) => ({
      isForgotPasswordStep: !isForgotPasswordStep,
    }));
  };

  render() {
    const { isOpen, closeModal } = this.props;
    const { isForgotPasswordStep } = this.state;

    return (
      <>
        {!isForgotPasswordStep && (
          <Modal isOpen={isOpen} onRequestClose={closeModal}>
            <div data-test-id="login-modal">
              <>
                <button
                  type="button"
                  aria-hidden="true"
                  onClick={closeModal}
                  className={styles.close}
                >
                  <MaterialIcon name="close" />
                </button>
                <div className={styles.container}>
                  <h2 className={styles.title}>
                    <FormattedMessage id="login/LoginModal.tsx/1" />
                  </h2>
                  <ConnectionForm
                    switchToForgotPassword={this.switchToForgotPassword}
                  />
                  <LoginModalFooter />
                </div>
              </>
            </div>
          </Modal>
        )}
        {isForgotPasswordStep && (
          <ResetPasswordModal
            isOpen={isOpen}
            closeModal={closeModal}
            data-test-id="forgot-modal"
          />
        )}
      </>
    );
  }
}
